// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SmartTextareaInput":"bgq_a bib_ve bib_vr bib_xh bib_vj"};